(function () {
  'use strict';

  function initialiseMobileCartLayer() {
    var carts = Array.prototype.slice.call(
      document.querySelectorAll('.w-commerce-commercecartwrapper')
    );

    if (!carts.length) return;

    function syncCartState() {
      var isOpen = carts.some(function (cart) {
        return cart.hasAttribute('data-cart-open');
      });

      document.documentElement.classList.toggle('mn-cart-is-open', isOpen);
      document.body.classList.toggle('mn-cart-is-open', isOpen);
    }

    carts.forEach(function (cart) {
      new MutationObserver(syncCartState).observe(cart, {
        attributes: true,
        attributeFilter: ['data-cart-open']
      });
    });

    window.addEventListener('pageshow', syncCartState);
    window.addEventListener('resize', syncCartState, { passive: true });
    syncCartState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseMobileCartLayer, { once: true });
  } else {
    initialiseMobileCartLayer();
  }
})();
